import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {

    // "ExampleNavBarItem": () => import("./components/navbar/filter/ExampleNavBarItem.vue"),

    // "ExampleTile1": () => import("./components/tiles/ExampleTile1.vue"),
    // "ExampleTile2": {
    //     meta:{
    //         i18nDescrKey: "example-tile-2",
    //         filters: [ "example-nav-bar-item" ],
    //         pinnable: true
    //     },
    //     component: () => import("./components/tiles/ExampleTile2.vue")
    // }
};

export default globals;
